import axios from 'axios'

const request = axios.create({
  // 生产环境
  baseURL: 'https://manage.shshtec.com/api/xhmobile'
})
export default request
